import React, { FC } from 'react'
import { useGiveawayPrizes } from '@/views/PreSales/PreSalesGiveawayView/hooks/useGiveawayPrizes'
import { GiveawayTabEnum, GiveawayTab } from '../../config'
import { useGiveawayContext } from '../../context/GiveawayContext'
import { PresaleDetailsTab } from './PresaleDetailsTab/PresaleDetailsTab'
import { PresalesFAQsTab } from './PresaleFAQsTab'
import { PresaleUpdatesTab } from './PresaleUpdatesTab'
import { PrizeItemsTab } from './PrizeItemsTab'

interface TabContentProps {
  tab: GiveawayTab
}

export const TabContent: FC<TabContentProps> = ({ tab }) => {
  const { theatricalSlug, giveawayData, sweepstake, scrollToProducts } = useGiveawayContext()
  const { galleryImages, videoImage } = giveawayData
  const { trailerYoutubeId, projectName, value } = sweepstake
  const prizes = useGiveawayPrizes(theatricalSlug)

  switch (tab.type) {
    case GiveawayTabEnum.Details:
      return (
        <PresaleDetailsTab
          theatricalSlug={theatricalSlug}
          prizes={prizes}
          trailerId={trailerYoutubeId}
          galleryImages={galleryImages}
          projectName={projectName}
          videoImage={videoImage}
          giveawayValue={value}
        />
      )

    case GiveawayTabEnum.Prizes:
      return prizes ? <PrizeItemsTab prizes={prizes} /> : null

    case GiveawayTabEnum.Updates:
      return <PresaleUpdatesTab scroll={scrollToProducts} />

    case GiveawayTabEnum.Faq:
      return <PresalesFAQsTab theatricalSlug={theatricalSlug} />

    default:
      return null
  }
}
